import { BookingAction } from '../actions/booking-action';
import {
  BookingParams,
  BookingPosition,
  BookingResult,
  StockSourceType,
} from '../types';
import { BookingWorld, WorldKind } from './booking-world';

/**
 * Weder KFZ noch Bufferstock aktiv. Jede Quelle liefert eine No-op-
 * Action, die Erfolg ohne Movement meldet ("keine Hintergrund-Verbuchung") -
 * harte Absicherung, falls die Validierung umgangen wird.
 */
class NoBookingAction extends BookingAction {
  /**
   * No-op-Ausführung: loggt nur eine Debug-Info und meldet Erfolg ohne Movement.
   * @param position Zu verbuchende Buchungsposition (nur für Debug-Log).
   * @param params Buchungsparameter (nur für Debug-Log).
   * @returns Ein Erfolgsergebnis ohne erzeugtes Movement.
   */
  public async execute(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    this.debugInfo(
      '[no-booking] keine Hintergrund-Verbuchung',
      position,
      params,
    );
    return this.success();
  }
}

/**
 * Welt ohne aktive Bestands-Funktionsschalter. Jede Quelle wird auf dieselbe
 * No-op-Action abgebildet.
 */
export class NoBookingWorld implements BookingWorld {
  public readonly kind: WorldKind = 'no-booking';

  private readonly noBooking = new NoBookingAction();

  /**
   * Liefert unabhängig von der Quelle die No-op-Action.
   * @param source Quell-Lagertyp der Buchung (wird ignoriert).
   * @returns Die geteilte No-op-Action.
   */
  public actionFor(source: StockSourceType): BookingAction {
    return this.noBooking;
  }
}
